import { 
    GET_ALL_USERS_OWNERS,
    CHANGE_USER_OWNERS,
    TOGGLE_CHECKED_ALL_USERS_OWNERS,
    CHANGE_STATUS_GET_FROM_DATABASE_ALL_OWNERS,
    SYNC_ALL_USERS_OWNERS,
}  from "../../core/constants";

//action creator
export function getAllUsersOwners ()
{
    return {
        type: GET_ALL_USERS_OWNERS
    }
}

export function syncUsersOwners (data)
{
    return {
        type: SYNC_ALL_USERS_OWNERS,
        payload: data
    }
}

//action creator
export function changeUserOwners (data)
{
    return {
        type: CHANGE_USER_OWNERS,
        payload: data,
    }
}

//action creator
export function toggleCheckedAllUsersOwners (status)
{
    return {
        type: TOGGLE_CHECKED_ALL_USERS_OWNERS,
        payload: status
    }
}

export function changeStatusGetFromDatabaseCompletedOwners (status)
{
    return {
        type: CHANGE_STATUS_GET_FROM_DATABASE_ALL_OWNERS,
        payload: status
    }
}